import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import api from '../api/Api';

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {});

  const [addresses, setAddresses] = useState(() => {
    const savedAddresses = localStorage.getItem('addresses');
    return savedAddresses ? JSON.parse(savedAddresses) : [];
  });

  const [orders, setOrders] = useState(() => {
    const savedOrders = localStorage.getItem('orders');
    return savedOrders ? JSON.parse(savedOrders) : [];
  });

 // ── Fetch user from API (not localStorage) ──
const fetchUser = useCallback(async () => {
  try {
    const { data } = await api.get('profile');
    if (data.status) {
      setUser(data);  // ✅ pura response set karo: data.USER, data.MASTERDATA etc.
    }
  } catch (err) {
    console.error('fetchUser error:', err);
    // 401 ho to logout
    if (err.response?.status === 401) {
      logout();
    }
  }
}, []);

// ── App load hote hi fetch karo ──
useEffect(() => {
  const token = localStorage.getItem('token');
  if (!token) return; // token nahi hai toh fetch mat karo
  fetchUser();
}, [fetchUser]);
  useEffect(() => {
    localStorage.setItem('addresses', JSON.stringify(addresses));
  }, [addresses]);

  useEffect(() => {
    localStorage.setItem('orders', JSON.stringify(orders));
  }, [orders]);

  // ── Auth actions ──

  const login = (userData) => {
    setUser(userData);
    toast.success(`Welcome back, ${userData.name}!`);
  };


const logout = async () => {


  try {
    await api.delete('logout');
  } catch (err) {
    console.error('Logout error:', err);
  } finally {
    setUser(null);
    ['user', 'addresses', 'orders', 'token'].forEach(key =>
      localStorage.removeItem(key)
    );
    toast.info('Logged out successfully');
    window.location.replace('/login');
  }
};

  // register: sirf user state set karta hai
  // token localStorage mein handleSubmit already set kar chuka hoga
  const register = (userData) => {
    setUser(userData);
    toast.success('Registration successful! Welcome to Bharti Jewellers!');
  };

  const updateProfile = (updatedData) => {
    setUser(prev => ({ ...prev, ...updatedData }));
    toast.success('Profile updated successfully');
  };

  // ── Address actions ──

  const addAddress = (address) => {
    const newAddress = { ...address, id: Date.now().toString() };
    setAddresses(prev => [...prev, newAddress]);
    toast.success('Address added successfully');
    return newAddress;
  };

  const updateAddress = (addressId, updatedAddress) => {
    setAddresses(prev =>
      prev.map(addr => addr.id === addressId ? { ...addr, ...updatedAddress } : addr)
    );
    toast.success('Address updated successfully');
  };

  const deleteAddress = (addressId) => {
    setAddresses(prev => prev.filter(addr => addr.id !== addressId));
    toast.info('Address deleted');
  };

  // ── Order actions ──

  const addOrder = (order) => {
    const newOrder = {
      ...order,
      id: Date.now().toString(),
      orderDate: new Date().toISOString(),
      status: 'Processing'
    };
    setOrders(prev => [newOrder, ...prev]);
    return newOrder;
  };

  const value = {
    user,
    addresses,
    orders,
    login,
    logout,
    register,
    updateProfile,
    addAddress,
    updateAddress,
    deleteAddress,
    addOrder,
    fetchUser,
    isAuthenticated: !!user
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;